import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n\tlist-style-type: none;\n\tpadding: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tlist-style-type: none;\n\tpadding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import { DesignTokenSizeEnum, styled } from '../theme-provider';
export { DesignTokenSizeEnum as ListGutter };
var StyledUList = styled.ul.withConfig({
  displayName: "StyledUList",
  componentId: "sc-1vgh97e"
})(_templateObject());
var StyledOList = styled.ol.withConfig({
  displayName: "StyledOList",
  componentId: "sc-vag0hz"
})(_templateObject2());
export var List = function List(props) {
  var children = props.children,
      gutter = props.gutter,
      _props$isOrdered = props.isOrdered,
      isOrdered = _props$isOrdered === void 0 ? false : _props$isOrdered;
  var childrenArr = React.Children.toArray(children);
  var markerSize = Math.floor(Math.pow(childrenArr.length, 1 / 10)) + 1;
  var childrenElements = childrenArr.map(function (child, index) {
    return React.cloneElement(child, {
      isOrdered: isOrdered,
      index: index + 1,
      gutter: gutter,
      markerSize: markerSize
    });
  });
  return isOrdered ? React.createElement(StyledOList, null, childrenElements) : React.createElement(StyledUList, null, childrenElements);
};